import S from '../Main.template.style';
import { PageLayoutContent } from './Content/PageLayoutContent';
import { PageLayoutProvider } from './Context/PageLayoutContext';
import type { IPageLayoutRight } from './types/PageLayoutRight.types';

const PageLayoutRight = ({
  sidebarOptions,
  topbarOptions,
  children,
  footerText,
  id,
  profileMenuOptions,
}: IPageLayoutRight) => {
  return (
    <PageLayoutProvider footerText={footerText}>
      <S.RightContainer id={id}>
        <PageLayoutContent
          sidebarOptions={sidebarOptions}
          topbarOptions={topbarOptions}
          profileMenuOptions={profileMenuOptions}
          id={id}
        >
          {children}
        </PageLayoutContent>
      </S.RightContainer>
    </PageLayoutProvider>
  );
};

export { PageLayoutRight };
